'use strict';

// .tooltip-product-promo lives inside .cart-product-card-wrapper, which clips
// overflow for its rounded corners. It's moved to <body> and positioned as
// position: fixed, clamped to the viewport, while open (see _tooltips.default.scss).
function isFloatingTooltip($tooltip) {
    return $tooltip.hasClass('tooltip-product-promo');
}

function positionFloatingTooltip($tooltip, $triggerBtn) {
    var MARGIN = 16;
    // must clear .icon-tooltip-triangle, which sticks out 20px past the tooltip's
    // own edge, or the triangle sits on top of the trigger and steals its clicks
    var GAP = 24;
    var triggerRect = $triggerBtn[0].getBoundingClientRect();
    var tooltipRect = $tooltip[0].getBoundingClientRect();
    var viewportWidth = document.documentElement.clientWidth;
    var viewportHeight = document.documentElement.clientHeight;

    var left = triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2);
    left = Math.max(MARGIN, Math.min(left, viewportWidth - tooltipRect.width - MARGIN));

    // opens above the trigger by default; if there isn't room, opens below instead -
    // clamping the "above" position downward would make it cover the trigger
    var spaceAbove = triggerRect.top - GAP - MARGIN;
    var openBelow = spaceAbove < tooltipRect.height;
    var top = openBelow ? (triggerRect.bottom + GAP) : (triggerRect.top - tooltipRect.height - GAP);
    top = Math.max(MARGIN, Math.min(top, viewportHeight - tooltipRect.height - MARGIN));

    $tooltip.css({ top: top + 'px', left: left + 'px' });
    $tooltip.toggleClass('tooltip--flip-down', openBelow);

    var $triangle = $tooltip.find('.icon-tooltip-triangle');
    if ($triangle.length) {
        // "left" positions the triangle's own left edge, not its visual center
        var triangleWidth = $triangle[0].getBoundingClientRect().width;
        var triangleTargetX = (triggerRect.left + (triggerRect.width / 2)) - left;
        var triangleLeft = triangleTargetX - (triangleWidth / 2);
        triangleLeft = Math.max(20, Math.min(triangleLeft, tooltipRect.width - 20 - triangleWidth));
        $triangle.css('left', triangleLeft + 'px');
    }
}

// some browsers paint a freshly shown box-shadow without the shadow if the
// element goes from hidden to visible within the same tick; one rAF forces
// a repaint first
function revealTooltipOnNextFrame($tooltip) {
    window.requestAnimationFrame(function () {
        $tooltip.css('visibility', '');
    });
}

function openFloatingTooltip($tooltip, $triggerBtn) {
    // marks where the tooltip sits so it can be moved back on close; re-created
    // on every open because replaceWith() on close detaches the previous one
    var $placeholder = $('<span class="d-none" aria-hidden="true"></span>');
    $tooltip.after($placeholder);
    $tooltip.data('floating-placeholder', $placeholder);
    $tooltip.data('floating-trigger', $triggerBtn);

    $tooltip.css('visibility', 'hidden');
    $('body').append($tooltip);
    positionFloatingTooltip($tooltip, $triggerBtn);
    revealTooltipOnNextFrame($tooltip);
}

function closeFloatingTooltip($tooltip) {
    var $placeholder = $tooltip.data('floating-placeholder');
    if ($placeholder && $placeholder.length) {
        $placeholder.replaceWith($tooltip);
    }
}

// a floating tooltip is moved to <body>, so closing the modal it was opened
// from doesn't touch it - leaves it stranded on screen otherwise
function closeAllFloatingTooltips() {
    $('body > .tooltip.tooltip-product-promo').not('.d-none').each(function () {
        var $openTooltip = $(this);
        var $storedTrigger = $openTooltip.data('floating-trigger');

        $openTooltip.addClass('d-none');
        if ($storedTrigger && $storedTrigger.length) {
            $storedTrigger.attr('aria-expanded', 'false');
        }
        closeFloatingTooltip($openTooltip);
    });
}

module.exports = function () {
    // general trigger for tooltips (promotions, punti natura, netreviews...)
    // matches: legacy accessible markup (div[role="button"].tooltip-trigger, e.g. cart/checkout summary),
    // native <button class="tooltip-trigger-btn"> inside a .tooltip-trigger wrapper (product tile, PDP fidelity, netreviews),
    // and a self-contained <button class="info-icon"> that has its own .tooltip as a direct child (checkout billing email/phone)
    $('.products, body').on('click', '.info-icon, .tooltip-trigger-btn', function (e) {
        // both the icon and its ancestor trigger can match the delegated selector;
        // stop here so the toggle below only runs once per click
        e.stopPropagation();

        var $self = $(this);
        var $trigger = $self.closest('.tooltip-trigger');

        var $triggerBtn = $self;
        if ($trigger.length) {
            $triggerBtn = $trigger.is('[role="button"]') ? $trigger : $trigger.find('.tooltip-trigger-btn').first();
        }

        // DOM traversal first - unlike aria-controls/getElementById, it can't be
        // thrown off by a duplicate id elsewhere on the page. Falls back to the
        // cached reference once the tooltip is floating (moved to <body>)
        var $tooltip = $trigger.length ? $trigger.find('.tooltip') : $self.find('.tooltip');
        if ($tooltip.length === 0) {
            $tooltip = $triggerBtn.data('tooltip-for');
            if (!$tooltip || $tooltip.length === 0 || $tooltip.closest('html').length === 0) {
                var controlsId = $triggerBtn.attr('aria-controls');
                $tooltip = controlsId ? $(document.getElementById(controlsId)) : $();
            }
        }
        if ($tooltip.length) {
            $triggerBtn.data('tooltip-for', $tooltip);
        }

        if ($tooltip.length === 0) {
            return;
        }

        if ($tooltip.hasClass('d-none')) {
            $triggerBtn.attr('aria-expanded', 'true');
            if (isFloatingTooltip($tooltip)) {
                $tooltip.removeClass('d-none');
                openFloatingTooltip($tooltip, $triggerBtn);
            } else {
                $tooltip.css('visibility', 'hidden');
                $tooltip.removeClass('d-none');
                revealTooltipOnNextFrame($tooltip);
            }
            $tooltip.focus();
        } else {
            $tooltip.addClass('d-none');
            $triggerBtn.attr('aria-expanded', 'false');
            if (isFloatingTooltip($tooltip)) {
                closeFloatingTooltip($tooltip);
            }
        }
    });

    // keyboard support for the legacy tooltip-trigger with role="button": Enter/Space toggle, Escape closes
    // (native <button> elements get Enter/Space activation for free from the browser)
    $('body').on('keydown', '.tooltip-trigger[role="button"]', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        } else if (e.key === 'Escape') {
            var $tooltip = $(this).find('.tooltip');
            if (!$tooltip.hasClass('d-none')) {
                $tooltip.addClass('d-none');
                $(this).attr('aria-expanded', 'false');
            }
        }
    });

    // fired by modalUtils.ts on every modal open AND close, despite the
    // "minicart"-specific name - it's a single shared MicroModal config
    $('body').on('minicartmodal:toggled', closeAllFloatingTooltips);

    // a floating tooltip's position is computed once, at open time - without
    // this it'd be left at stale coordinates if the window is resized while open
    var resizeRaf = null;
    $(window).on('resize', function () {
        if (resizeRaf) {
            return;
        }
        resizeRaf = window.requestAnimationFrame(function () {
            resizeRaf = null;
            $('body > .tooltip.tooltip-product-promo').not('.d-none').each(function () {
                var $openTooltip = $(this);
                var $storedTrigger = $openTooltip.data('floating-trigger');
                if ($storedTrigger && $storedTrigger.length) {
                    positionFloatingTooltip($openTooltip, $storedTrigger);
                }
            });
        });
    });

    // keyboard support for tooltip dialog: Escape closes and returns focus to its trigger
    $('body').on('keydown', '.tooltip[role="dialog"]', function (e) {
        if (e.key === 'Escape') {
            var $tooltip = $(this);
            // a floating .tooltip-product-promo has been moved to <body>, so it's no
            // longer a descendant of .tooltip-trigger - closest() won't find it there
            var $storedTrigger = $tooltip.data('floating-trigger');
            var $trigger = $tooltip.closest('.tooltip-trigger');
            var $triggerBtn = $trigger.is('[role="button"]') ? $trigger : $trigger.find('.tooltip-trigger-btn').first();
            if ($storedTrigger && $storedTrigger.length) {
                $triggerBtn = $storedTrigger;
            }

            $tooltip.addClass('d-none');
            $triggerBtn.attr('aria-expanded', 'false');
            $triggerBtn.focus();

            if (isFloatingTooltip($tooltip)) {
                closeFloatingTooltip($tooltip);
            }
        }
    });
};
